export function initializeAnalytics() {
  const GTM_ID = import.meta.env.VITE_GOOGLE_TAGMANAGER_ID;
  const GA_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;

  // GTM Script
  const gtmScript = document.createElement('script');
  gtmScript.type = 'text/javascript';
  gtmScript.defer = true;
  const gtmContent = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');
  `;
  gtmScript.textContent = gtmContent;
  document.head.insertBefore(gtmScript, document.head.firstChild);

  // GA4 Script
  const gaScript = document.createElement('script');
  gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  gaScript.async = true;
  gaScript.defer = true;
  document.head.appendChild(gaScript);

  gaScript.onload = () => {
    const gaInitScript = document.createElement('script');
    gaInitScript.type = 'text/javascript';
    gaInitScript.defer = true;
    const gaContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_ID}');
    `;
    gaInitScript.textContent = gaContent;
    document.head.appendChild(gaInitScript);
  };

  // GTM noscript iframe
  const noscriptIframe = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscriptIframe.appendChild(iframe);
  document.body.insertBefore(noscriptIframe, document.body.firstChild);
} 